// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"578":"8c77b629","798":"8beee612"}[chunkId] + ".chunk.css";
};